export default __webpack_public_path__ + "static/media/icon-us-flag.406e3dbd.png";